import Api from '../../base/api.typings';
import axiosConfiguration from '@/base/axios-configuration';

class EmpresaService {
    async obterParaEditar(query?: Api.App.Server.Empresa.InserirEditar.Query): Promise<Api.App.Server.Empresa.InserirEditar.Command> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Empresa/ObterParaEditar', { params: query }).then(e => e.data);
    }

    async listar(query: Api.App.Server.Empresa.Listar.Query): Promise<Api.App.Server.Empresa.Listar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Empresa/listar', { params: query }).then(e => e.data);
    }

    async excluir(command: Api.App.Server.Empresa.Excluir.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Empresa/Excluir', command);
    }

    async inserir(command: Api.App.Server.Empresa.InserirEditar.Command): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Empresa/Inserir', command).then(r => r.data);
    }

    async editar(command: Api.App.Server.Empresa.InserirEditar.Command): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().put('/api/Empresa/Editar', command);
    }

    async obterCnae(query: string): Promise<object> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('https://servicodados.ibge.gov.br/api/v2/cnae/classes/'+query+'/subclasses').then(e => e.data);
    }

} 

export default new EmpresaService();